export const AUTH_COOKIE = 'PENYA_TOKEN';

const leerCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

// Se mantiene PHPSESSID como alias para no cambiar todas las llamadas existentes.
// El token de la aplicacion usa otro nombre y no choca con la cookie HttpOnly de PHP.
export const getCookie = (name) => {
  if (name === 'PHPSESSID') {
    return leerCookie(AUTH_COOKIE) || leerCookie('PHPSESSID');
  }
  return leerCookie(name);
};

export const guardarTokenSesion = (token, expires) => {
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${AUTH_COOKIE}=${encodeURIComponent(token)}; path=/; expires=${expires.toUTCString()}; SameSite=Lax${secure}`;
};

export const borrarTokenSesion = () => {
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${AUTH_COOKIE}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax${secure}`;
  // Limpia el nombre usado por versiones anteriores cuando no sea HttpOnly.
  document.cookie = `PHPSESSID=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax${secure}`;
};
